var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDislike(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.059 6.799h-1.96c-.755 0-1.37.535-1.37 1.193v.25c-1.185-.526-3.877-1.443-8.254-1.443H7.22c-1.816 0-3.358 1.13-3.668 2.687l-.877 4.432c-.186.945.115 1.906.823 2.639.708.73 1.746 1.15 2.844 1.15h3.555a5.638 5.638 0 0 0-.443 2.215c0 2.561 1.666 3.238 2.547 3.238 1.627 0 1.764-1.32 1.764-2.557 0-1.509 1.945-2.763 2.973-3.321.053.617.64 1.106 1.36 1.106h1.96c.756 0 1.372-.535 1.372-1.193V7.992c0-.659-.616-1.193-1.372-1.193zM12.59 20.604c0 1.534-.299 1.534-.588 1.534-.552 0-1.37-.591-1.37-2.216 0-1.511.678-2.437.684-2.444a.455.455 0 0 0 .029-.524.604.604 0 0 0-.518-.27H6.345c-.752 0-1.462-.287-1.945-.787-.485-.5-.69-1.159-.563-1.805l.876-4.432c.211-1.064 1.266-1.838 2.509-1.838h1.254c5.331 0 8.002 1.45 8.253 1.594v6.688c-.653.3-4.139 2.026-4.139 4.5h.001zm7.665-3.409c0 .094-.087.17-.196.17H18.1c-.107 0-.195-.076-.195-.17V7.992c0-.093.09-.17.196-.17h1.958c.108 0 .196.076.196.17v9.203h.001z",
    fill: "#9D9D9D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDislike);
export default __webpack_public_path__ + "static/media/dislike.44023948fc5301287e092d96406e45ae.svg";
export { ForwardRef as ReactComponent };